import { Dropdown, Tabs } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import '../../styles.scss'
import CarFeilds from '../InfoCar/CarFeilds';
import { PlusCircleOutlined, PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { FlattenedField } from '../../../CustomersV2/indexV2';
import { FieldsUpdate, getInfoCustomerComplaint, getInfoCustomerSurvey, getListClientCampaign, getListClientVoucher, getListCustomerCareAndService, getListCustomerComplaints, getListCustomerSurvey, getListFieldsByCustomer, IComplaintDetail, ICustomer, IInfoSurvey, ListField, updateFieldUser } from '../../../../api/Customer_V2/customerApi_V2';
import TabSalesAndService from './TabInteractionHistory/TabSalesAndService';
import TabSupportHistory from './TabInteractionHistory/TabSupportHistory';
import { IPagination } from '../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { ICustomerDetail_V4 } from '../../../../api/customer/customerApi';
import useToast from '../../../../hook/useToast';
import useLoading from '../../../../hook/useLoading';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';
import { selectorCategoryCarIds } from '../../../../store/slices/categoryCarSlice';
import useDebounce from '../../../../hook/useDebounce';
import { PaginationProps } from 'antd/lib';
import TabSurveyInformation from './TabInteractionHistory/TabSurveyInformation';
import { FIELDTYPE } from '../../../../services/data';
import useThrottle from '../../../../hook/useThrottle';
import ServiceRecordFeilds from '../ServiceRecords/Components/ServiceRecordFeilds';
import { flattenFields } from '../../../../until';
import TabMarketing from './TabInteractionHistory/TabMarketing';
import TabVoucher from './TabInteractionHistory/TabVoucher';

interface IDataFilterActive {
  salesAndService: FlattenedField[];
  supportHistory: FlattenedField[];
  surveyInformation: FlattenedField[];
  marketing: FlattenedField[];
  voucher: FlattenedField[];
}
interface IDataFilterNoActive {
  salesAndService: ListField[];
  supportHistory: ListField[];
  surveyInformation: ListField[];
  marketing: ListField[];
  voucher: ListField[];
}

export interface IDataFilter {
  marketting: {
    search: string,
    fromDate: string,
    toDate: string
  },
  voucher: {
    search: string,
    fromDate: string,
    toDate: string
  },
}

const DataFilterInit = {
  marketting: {
    search: '',
    fromDate: '',
    toDate: ''
  },
  voucher: {
    search: '',
    fromDate: '',
    toDate: ''
  },
}

const EMPTY_GROUP = {
  salesAndService: [],
  supportHistory: [],
  surveyInformation: [],
  marketing: [],
  voucher: [],
};

type PaginationKey = "salesAndService" | "supportHistory" | "surveyInformation" | "marketing" | "voucher";

interface Props {
  infoCustomer?: ICustomerDetail_V4;
}

const TabInteractionHistory: React.FC<Props> = ({
  infoCustomer
}) => {
  useEffect(() => {
    gListFieldsActive()
  }, [])

  const pushToast = useToast();
  const pushLoading = useLoading()
  const { id, unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const { id: idCustomer } = infoCustomer ?? {}

  const [isSettingShow, setSettingShow] = useState(false)
  const [isModalSupportHistoryAdd, setIsModalSupportHistoryAdd] = useState<boolean>(false)
  const [isModalSupportHistoryDetail, setIsModalSupportHistoryDetail] = useState<boolean>(false)
  const [isModalSupportHistoryUpdate, setIsModalSupportHistoryUpdate] = useState<boolean>(false)
  const [isModalSalesAndServiceScheduleARepairAdd, setIsModalSalesAndServiceScheduleARepairAdd] = useState<boolean>(false)
  const [isModalSalesAndServiceScheduleARepairUpdate, setIsModalSalesAndServiceScheduleARepairUpdate] = useState<boolean>(false)
  const [isModalSalesAndServiceAdd, setIsModalSalesAndServiceAdd] = useState<boolean>(false)
  const [isModalSalesAndServiceUpdate, setIsModalSalesAndServiceUpdate] = useState<boolean>(false)
  const [isModalSalesAndServiceDetail, setIsModalSalesAndServiceDetail] = useState<boolean>(false)
  // Khảo sát
  const [isModalModalSurveyInformationAdd, setIsModalModalSurveyInformationAdd] = useState<boolean>(false)
  const [isModalModalSurveyInformationDetail, setIsModalModalSurveyInformationDetail] = useState<boolean>(false)
  const [isModalModalSurveyInformationUpdate, setIsModalModalSurveyInformationUpdate] = useState<boolean>(false)


  const [activeTab, setActiveTab] = useState<PaginationKey>("salesAndService");
  const [dataFieldsActive, setDataFieldsActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsNoActive, setDataFieldsNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    salesAndService: { current: 1, pageSize: 10, total: 0 },
    supportHistory: { current: 1, pageSize: 10, total: 0 },
    surveyInformation: { current: 1, pageSize: 10, total: 0 },
    marketing: { current: 1, pageSize: 10, total: 0 },
    voucher: { current: 1, pageSize: 10, total: 0 },
  });

  const [loadingTable, setLoadingTable] = useState(false);

  const [infoSupportHistory, setInfoSupportHistory] = useState<IComplaintDetail>();
  const [infoSurveyInformation, setInfoSurveyInformation] = useState<IInfoSurvey>();

  const [salesAndService, setSalesAndService] = useState<ICustomer[]>([]);
  const [supportHistory, setSupportHistory] = useState<ICustomer[]>([]);
  const [surveyInformation, setSurveyInformation] = useState<ICustomer[]>([]);
  const [marketing, setMarketing] = useState<ICustomer[]>([]);
  const [voucher, setVoucher] = useState<ICustomer[]>([]);


  const [dataFilter, setDataFilter] = useState<IDataFilter>(DataFilterInit)

  const gListFieldsActive = async () => {
    const [salesAndServiceRes, supportHistoryRes, surveyInformationRes, marketingRes, voucherRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SalesAndService, 1),
        getListFieldsByCustomer(FIELDTYPE.SupportHistory, 1),
        getListFieldsByCustomer(FIELDTYPE.SurveyInformation, 1),
        getListFieldsByCustomer(FIELDTYPE.MarketingCampaign, 1),
        getListFieldsByCustomer(FIELDTYPE.Voucher, 1),
      ]);

    const flattenedFieldsSalesAndService = flattenFields(salesAndServiceRes?.data ?? []);
    const flattenedFieldsSupportHistory = flattenFields(supportHistoryRes?.data ?? []);
    const flattenedFieldsSurveyInformation = flattenFields(surveyInformationRes?.data ?? []);
    const flattenedFieldsMarketing = flattenFields(marketingRes?.data ?? []);
    const flattenedFieldsVoucher = flattenFields(voucherRes?.data ?? []);

    setDataFieldsActive({
      salesAndService: flattenedFieldsSalesAndService,
      supportHistory: flattenedFieldsSupportHistory,
      surveyInformation: flattenedFieldsSurveyInformation,
      marketing: flattenedFieldsMarketing,
      voucher: flattenedFieldsVoucher,
    });

    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    const [salesAndServiceNoActiveRes, supportHistoryNoActiveRes, surveyInformationNoActiveRes, marketingNoActiveRes, voucherNoActiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SalesAndService, 0),
        getListFieldsByCustomer(FIELDTYPE.SupportHistory, 0),
        getListFieldsByCustomer(FIELDTYPE.SurveyInformation, 0),
        getListFieldsByCustomer(FIELDTYPE.MarketingCampaign, 0),
        getListFieldsByCustomer(FIELDTYPE.Voucher, 0),
      ]);

    setDataFieldsNoActive({
      salesAndService: salesAndServiceNoActiveRes?.data ?? [],
      supportHistory: supportHistoryNoActiveRes?.data ?? [],
      surveyInformation: surveyInformationNoActiveRes?.data ?? [],
      marketing: marketingNoActiveRes?.data ?? [],
      voucher: voucherNoActiveRes?.data ?? [],
    })
  };

  const gListCustomerCareAndService = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer) return;
    setLoadingTable(true)
    const result = await getListCustomerCareAndService(
      idCustomer, unitTemp, permittedCategoryCarIds,
      undefined, pageSize, pageCurent
    )
    if (result?.status) {
      setSalesAndService(result.data)
      setPaginationMap(prev => ({
        ...prev,
        salesAndService: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListCustomerComplaints = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer) return;
    setLoadingTable(true)
    const result = await getListCustomerComplaints(
      idCustomer, unitTemp, permittedCategoryCarIds,
      undefined, pageSize, pageCurent
    )
    if (result?.status) {
      setSupportHistory(result.data)
      setPaginationMap(prev => ({
        ...prev,
        supportHistory: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListCustomerSurvey = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer) return;
    setLoadingTable(true)
    const result = await getListCustomerSurvey(
      idCustomer, unitTemp, permittedCategoryCarIds,
      undefined, pageSize, pageCurent
    )
    if (result?.status) {
      setSurveyInformation(result.data)
      setPaginationMap(prev => ({
        ...prev,
        surveyInformation: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListClientCampaign = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer) return;
    const { search, fromDate, toDate } = dataFilter.marketting
    setLoadingTable(true)
    const result = await getListClientCampaign(
      idCustomer, unitTemp, permittedCategoryCarIds,
      pageSize, pageCurent, search, fromDate, toDate
    )
    if (result?.status) {
      setMarketing(result.data)
      setPaginationMap(prev => ({
        ...prev,
        marketing: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListClientVoucher = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    if (!idCustomer) return;
    const { search, fromDate, toDate } = dataFilter.voucher
    setLoadingTable(true)
    const result = await getListClientVoucher(
      idCustomer, unitTemp, permittedCategoryCarIds,
      pageSize, pageCurent, search, fromDate, toDate
    )
    if (result?.status) {
      setVoucher(result.data)
      setPaginationMap(prev => ({
        ...prev,
        voucher: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeTab) {
      case 'salesAndService': {
        result = await updateFieldUser(id, FIELDTYPE.SalesAndService, undefined, listActiveFields)
        break;
      }
      case 'supportHistory': {
        result = await updateFieldUser(id, FIELDTYPE.SupportHistory, undefined, listActiveFields)
        break;
      }
      case 'surveyInformation': {
        result = await updateFieldUser(id, FIELDTYPE.SurveyInformation, undefined, listActiveFields)
        break;
      }
      case 'marketing': {
        result = await updateFieldUser(id, FIELDTYPE.MarketingCampaign, undefined, listActiveFields)
        break;
      }
      case 'voucher': {
        result = await updateFieldUser(id, FIELDTYPE.Voucher, undefined, listActiveFields)
        break;
      }
      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsActive(prev => ({
          ...prev,
          [activeTab]: dataFilterActive ?? [],
        }));

        setDataFieldsNoActive(prev => ({
          ...prev,
          [activeTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)


  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeTab) {
      case "salesAndService": {
        gListCustomerCareAndService(pageNumber, pageSize)
        break;
      }
      case "supportHistory": {
        gListCustomerComplaints(pageNumber, pageSize)
        break;
      }
      case "surveyInformation": {
        gListCustomerSurvey(pageNumber, pageSize)
        break;
      }
      case "marketing": {
        gListClientCampaign(pageNumber, pageSize)
        break;
      }
      case "voucher": {
        gListClientVoucher(pageNumber, pageSize)
        break;
      }
      default:
        break;
    }
  }
  //#region modal Chăm sóc dịch vụ

  const resultFormSubmitSalesAndService = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {

      pushToast(message, "success")
      gListCustomerCareAndService(paginationMap[activeTab].current, paginationMap[activeTab].pageSize)

      setIsModalSalesAndServiceScheduleARepairAdd(false)
      setIsModalSalesAndServiceScheduleARepairUpdate(false)
      setIsModalSalesAndServiceAdd(false)
      setIsModalSalesAndServiceUpdate(false)
      // setIsModalSupportHistoryDetail(false)
      // setIsModalSupportHistoryUpdate(false)
      // setInfoSupportHistory(undefined)
    }
    else {
      pushToast(message, "error")
    }
  }


  //#endregion

  //#region modal lịch sử hỗ trợ, khiếu nại
  const openModalSupportHistoryDetail = async (value: number) => {
    pushLoading(true)
    const result = await getInfoCustomerComplaint(
      value
    )
    if (result?.status) {
      setInfoSupportHistory(result.data)
      setIsModalSupportHistoryDetail(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const openModalSupportHistoryUpdate = async (value: number) => {
    pushLoading(true)

    const result = await getInfoCustomerComplaint(
      value
    )
    if (result?.status) {
      setInfoSupportHistory(result.data)
      setIsModalSupportHistoryUpdate(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const resultFormSubmitSupportHistory = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      gListCustomerComplaints(paginationMap[activeTab].current, paginationMap[activeTab].pageSize)
      setIsModalSupportHistoryAdd(false)
      setIsModalSupportHistoryDetail(false)
      setIsModalSupportHistoryUpdate(false)
      setInfoSupportHistory(undefined)
    }
    else {
      pushToast(message, "error")
    }
  }

  //#endregion

  //#region modal thông tin khảo sát
  const resultFormSubmitSurveyInformation = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      gListCustomerSurvey(paginationMap[activeTab].current, paginationMap[activeTab].pageSize)
      setIsModalModalSurveyInformationAdd(false)
      setIsModalModalSurveyInformationUpdate(false)
    }
    else {
      pushToast(message, "error")
    }
  }

  const openModalSubmitSurveyInformation = async (value: number) => {

    pushLoading(true)
    const result = await getInfoCustomerSurvey(
      value
    )
    if (result?.status) {
      setInfoSurveyInformation(result.data)
      setIsModalModalSurveyInformationUpdate(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }
  //#endregion

  useEffect(() => {
    if (idCustomer) {

      gListCustomerCareAndService()
      gListCustomerComplaints()
      gListCustomerSurvey()
      gListClientCampaign()
      gListClientVoucher()
    }
  }, [idCustomer])

  useEffect(() => {
    if (activeTab === 'marketing') {
      gListClientCampaign()
    } else {
      gListClientVoucher()
    }
  }, [dataFilter])

  // useEffect(() => {
  //   setDataFilter(DataFilterInit)
  // }, [activeTab])

  return (
    <Fragment>



      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            type={0}
            dataFilterActive={dataFieldsActive[activeTab]}
            dataFilterNoActive={dataFieldsNoActive[activeTab]}

            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
        <div className="custom-page-css w-full flex items-center justify-between gap-3  relative">
          <Tabs
            activeKey={activeTab}
            items={[
              {
                key: 'salesAndService',
                label: <span className='custom-page-css font-light text-lg'>Chăm sóc bán hàng, dịch vụ</span>,
                children:
                  <TabSalesAndService
                    loadingTable={loadingTable}
                    isModalSalesAndServiceDetail={isModalSalesAndServiceDetail}
                    isModalSalesAndServiceScheduleARepairAdd={isModalSalesAndServiceScheduleARepairAdd}
                    isModalSalesAndServiceScheduleARepairUpdate={isModalSalesAndServiceScheduleARepairUpdate}
                    isModalSalesAndServiceUpdate={isModalSalesAndServiceUpdate}
                    isModalSalesAndServiceAdd={isModalSalesAndServiceAdd}

                    dataFieldsActive={dataFieldsActive.salesAndService}
                    pagination={paginationMap.salesAndService}
                    idCustomer={infoCustomer?.id}
                    data={salesAndService}

                    setIsModalSalesAndServiceDetail={setIsModalSalesAndServiceDetail}
                    setIsModalSalesAndServiceScheduleARepairAdd={setIsModalSalesAndServiceScheduleARepairAdd}
                    setIsModalSalesAndServiceScheduleARepairUpdate={setIsModalSalesAndServiceScheduleARepairUpdate}
                    setIsModalSalesAndServiceUpdate={setIsModalSalesAndServiceUpdate}
                    setIsModalSalesAndServiceAdd={setIsModalSalesAndServiceAdd}

                    onPaginationChange={onPaginationChange}

                    resultFormSubmitSalesAndService={resultFormSubmitSalesAndService}

                  />
                ,
              },
              {
                key: 'supportHistory',
                label: <span className='custom-page-css font-light text-lg'>Lịch sử hỗ trợ, khiếu nại</span>,
                children:
                  <TabSupportHistory
                    loadingTable={loadingTable}
                    isModalSupportHistoryAdd={isModalSupportHistoryAdd}
                    isModalSupportHistoryDetail={isModalSupportHistoryDetail}
                    isModalSupportHistoryUpdate={isModalSupportHistoryUpdate}
                    infoSupportHistoryDetail={infoSupportHistory}

                    dataFieldsActive={dataFieldsActive.supportHistory}
                    pagination={paginationMap.supportHistory}
                    idCustomer={infoCustomer?.id}
                    data={supportHistory}

                    onPaginationChange={onPaginationChange}
                    openModalDetail={openModalSupportHistoryDetail}
                    openModalUpdate={openModalSupportHistoryUpdate}

                    setIsModalSupportHistoryAdd={setIsModalSupportHistoryAdd}
                    setIsModalSupportHistoryDetail={setIsModalSupportHistoryDetail}
                    setIsModalSupportHistoryUpdate={setIsModalSupportHistoryUpdate}


                    resultFormSubmitSupportHistory={resultFormSubmitSupportHistory}

                  />
                ,
              },
              {
                key: 'surveyInformation',
                label: <span className='custom-page-css font-light text-lg'>Thông tin khảo sát</span>,
                children:
                  <TabSurveyInformation
                    loadingTable={loadingTable}
                    isModalModalSurveyInformationAdd={isModalModalSurveyInformationAdd}
                    isModalModalSurveyInformationDetail={isModalModalSurveyInformationDetail}
                    isModalModalSurveyInformationUpdate={isModalModalSurveyInformationUpdate}

                    dataFieldsActive={dataFieldsActive.surveyInformation}
                    pagination={paginationMap.surveyInformation}
                    idCustomer={infoCustomer?.id}
                    infoSurveyInformationDetail={infoSurveyInformation}
                    data={surveyInformation}


                    setIsModalSurveyInformationDetail={setIsModalModalSurveyInformationDetail}
                    setIsModalSurveyInformationAdd={setIsModalModalSurveyInformationAdd}
                    setIsModalModalSurveyInformationUpdate={setIsModalModalSurveyInformationUpdate}

                    onPaginationChange={onPaginationChange}
                    resultFormSubmitSurveyInformation={resultFormSubmitSurveyInformation}
                    openModalUpdate={openModalSubmitSurveyInformation}


                  />
                ,
              },
              {
                key: 'marketing',
                label: <span className='custom-page-css font-light text-lg'>Marketing</span>,
                children:
                  <TabMarketing
                    loadingTable={loadingTable}
                    idCustomer={infoCustomer?.id}
                    dataFilter={dataFilter}

                    data={marketing}
                    dataFieldsActive={dataFieldsActive.marketing}
                    pagination={paginationMap.marketing}

                    setDataFilter={setDataFilter}
                    onPaginationChange={onPaginationChange}

                  />
              },
              {
                key: 'voucher',
                label: <span className='custom-page-css font-light text-lg'>Voucher</span>,
                children:
                  <TabVoucher
                    loadingTable={loadingTable}
                    idCustomer={infoCustomer?.id}
                    dataFilter={dataFilter}

                    data={voucher}
                    dataFieldsActive={dataFieldsActive.voucher}
                    pagination={paginationMap.voucher}

                    setDataFilter={setDataFilter}
                    onPaginationChange={onPaginationChange}
                  />
              },
            ]}
            onChange={(e) => setActiveTab(e as PaginationKey)}
            className='w-full'
          />
          <div className="custom-page-css absolute top-1 right-0">
            <div className=' custom-page-css w-full flex items-center gap-3'>
              {
                activeTab === "supportHistory" && (
                  <div className='settingCol'>
                    <div className='ctr-col-setting'
                      onClick={() => setIsModalSupportHistoryAdd(true)}
                    >
                      <PlusOutlined />
                    </div>
                  </div>
                )

              }
              {
                activeTab === "surveyInformation" && (
                  <div className='settingCol'>
                    <div className='ctr-col-setting'
                      onClick={() => setIsModalModalSurveyInformationAdd(true)}
                    >
                      <PlusOutlined />
                    </div>
                  </div>
                )

              }
              {
                activeTab === "salesAndService" && (
                  <div className='settingCol'>
                    <div className='ctr-col-setting'>
                      {/* <MoreOutlined /> */}
                      {/* <Dropdown menu={{ items }} trigger={['click']}>
                                <PlusOutlined />
                            </Dropdown> */}
                      <Dropdown
                        menu={{
                          items: [
                            { key: 1, label: 'Đặt lịch hẹn sửa chữa' },
                            { key: 2, label: 'Chăm sóc bán hàng, dịch vụ' },
                          ],
                          onClick: ({ key }) => {
                            switch (true) {
                              case Number(key) === 1:
                                setIsModalSalesAndServiceScheduleARepairAdd(true)
                                break;
                              default:
                                setIsModalSalesAndServiceAdd(true)
                                break;
                            }
                          },
                        }}
                        trigger={["click"]}
                        placement="bottomLeft"

                      >
                        <PlusOutlined />
                      </Dropdown>
                    </div>
                  </div>
                )
              }
              <div className='settingCol'>
                <div className='ctr-col-setting'
                  onClick={() => setSettingShow(true)}
                >
                  <SettingOutlined />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default TabInteractionHistory
